import useSWR from "swr";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { fetcher } from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { StatusChip } from "@/components/common";

export const AlertsBell = () => {
  const { data } = useSWR("/alerts", fetcher, { refreshInterval: 120000 });
  const navigate = useNavigate();
  const triggered = data?.alerts?.filter((a) => a.count > 0) || [];
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button data-testid="alerts-bell" className="relative h-9 w-9 rounded-md flex items-center justify-center hover:bg-slate-100 dark:hover:bg-slate-800" title="Alerts">
          <Bell size={16} />{triggered.length > 0 && <span data-testid="alerts-count" className="absolute -top-0.5 -right-0.5 h-4 min-w-4 px-1 rounded-full bg-rose-600 text-white text-[10px] font-semibold flex items-center justify-center">{triggered.length}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-96 p-0" data-testid="alerts-popover">
        <div className="px-4 py-3 border-b text-sm font-semibold">Alerts · evaluated against live engine metrics</div>
        <div className="max-h-80 overflow-auto divide-y">
          {(data?.alerts || []).map((a) => (
            <button key={a.id} data-testid={`alert-${a.id}`} onClick={() => navigate(a.link)} className="w-full text-left px-4 py-2.5 hover:bg-slate-50 dark:hover:bg-slate-800">
              <div className="flex items-center justify-between gap-2"><span className="text-sm font-medium">{a.name}</span><StatusChip value={a.count > 0 ? a.severity : "low"} label={a.count > 0 ? `${a.count}` : "clear"} className="!normal-case" /></div>
              <div className="text-xs text-slate-500 mt-0.5 font-mono">{a.metric} {a.operator} {String(a.threshold)}{a.sample?.length ? ` · ${a.sample.slice(0, 2).join(", ")}` : ""}</div>
            </button>
          ))}
          {!data && <div className="px-4 py-6 text-sm text-slate-500">Evaluating…</div>}
        </div>
        <div className="px-4 py-2 border-t text-[11px] text-slate-500">Rules are configured in Admin → Alert Rules</div>
      </PopoverContent>
    </Popover>
  );
};
